import { render, staticRenderFns } from "./test2.vue?vue&type=template&id=36dd660d"
import script from "./test2.vue?vue&type=script&lang=js"
export * from "./test2.vue?vue&type=script&lang=js"
import style0 from "./test2.vue?vue&type=style&index=0&id=36dd660d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports